import { Locale } from '../entities/Locale';
import nl from 'date-fns/locale/nl';
import en from 'date-fns/locale/en-GB';
import de from 'date-fns/locale/de';

export const getDateFnsLocale = (locale: Locale) => ({ nl, de, en }[locale]);
